const FileNames = {
	FulfillmentOrder: 'Fulfillment Orders',
	Product: 'Products',
	ShipmentInfo: 'Fulfillment Shipments',
	ShipmentInfoReturn: 'Return Shipments',
	PickingBatch: 'Batches',
	MarketplaceOrder: 'Marketplace Orders',
	Receiving: 'Containers',
};

export { FileNames };



// WEBPACK FOOTER //
// ./src/common/constants/fileNames.js